import React, { Component } from "react";
import { PATHS } from "../../constant";
import LoginDesc from "./LoginDesc";
import { withCookies } from "react-cookie";
import UserVerification from "./UserVerification";
import SecuredKeyClock from "./SecuredKeyClock";

class LoginUserVerification extends Component {
  render() {
    const { cookies, history, location } = this.props;
    const { state } = location;

    return (
      <SecuredKeyClock
        cookies={cookies}
        onLoad="login-required"
        state={state}
      />
    );
  }
}

export default withCookies(LoginUserVerification);
